import MapSearchLinkBlock from './map-search-link-block';

export default MapSearchLinkBlock;
